<template>
    <div class="form__field file-input">
        <div
            v-if="allowDragAndDrop"
            v-show="mode !== 'imgUploaded'"
            :class="dropAreaClass"
            @dragover="setOverClass"
            @dragenter="setOverClass"

            @dragleave="removeOverClass"
            @dragend="removeOverClass"
            @drop="removeOverClass"
        >
            <div class="content">
                <template v-if="dropAreaLabel">
                    <div class="drop-area__label">
                        {{ $t(dropAreaLabel) }}
                    </div>
                    <div class="drop-area__or">
                        {{ $t('or') | upperCase }}
                    </div>
                </template>
                <input
                    v-bind="$attrs"
                    @change="onChange"
                    type="file"
                    ref="input"
                    class="file-input"
                    :tabIndex="-1"
                >
                <button class="btn" type="button">
                    {{ $t(buttonLabel) | upperCase }}
                </button>
            </div>
        </div>
        <template v-else>
            <label class="input__label">{{ $t(label) | capitalize }}</label>
            <input
                v-bind="$attrs"
                @change="onChange"
                type="file"
                ref="input"
            >
        </template>
        <template v-if="mode === 'imgUploaded'">
            <div class="image-container">
                <img v-bind="img">
            </div>
            <button
                v-if="mode === 'imgUploaded'"
                @click="onUploadButtonClick"
                class="btn btn__secondary upload-button"
                type="button"
            >
                {{ $t(buttonLabel) | upperCase }}
            </button>
        </template>
        <div
            v-if="errorMessage"
            class="message message--error"
        >
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { errorGuard } from '@app/utils';

    const DROP_AREA_HEIGHT = 200;
    const DROP_AREA_WIDTH = 400;

    const determineImageDimensions = (height, width) => {
        let coefficient = DROP_AREA_HEIGHT / height;
        const scaledWidth = coefficient * width;
        if (scaledWidth <= DROP_AREA_WIDTH) {
            return {
                width: scaledWidth,
                height: DROP_AREA_HEIGHT,
            };
        }
        coefficient = DROP_AREA_WIDTH / width;
        const scaledHeight = coefficient * height;
        return {
            width: DROP_AREA_WIDTH,
            height: scaledHeight
        };
    };

    const readURL = function (file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        return new Promise((resolve) => {
            reader.onload = (e) => {
                const img = new Image();
                img.src = e.target.result;
                img.onload = function () {
                    const {
                        height,
                        width,
                    } = determineImageDimensions(this.height, this.width);
                    resolve({
                        height,
                        width,
                        src: this.src,
                    });
                };
            };
        });
    };

    export default Vue.component('CustomFileInput', {
        props: {
            value: {
                type: FileList,
                default: null,
            },
            name: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: false,
                default: ''
            },
            buttonLabel: {
                type: String,
                default: 'browse files',
            },
            dropAreaLabel: {
                type: String,
                default: null,
            },
            errorMessage: {
                type: String,
                required: false,
                default: null,
            },
            allowDragAndDrop: {
                type: Boolean,
            }
        },
        data() {
            return {
                dropAreaClass: {
                    'drop-area': true,
                    over: false,
                },
                files: [],
                img: null,
                mode: 'upload',
            };
        },
        watch: {
            async files() {
                await errorGuard({
                    action: async () => {
                        const lastUploadedFile = this.files[this.files.length - 1];
                        if (this.isImage(lastUploadedFile)) {
                            const img = await readURL(lastUploadedFile);
                            this.img = img;
                            this.mode = 'imgUploaded';
                        } else {
                            // display another image
                            // we'll see with designers if this case comes up
                        }
                    },
                });
            },
        },
        methods: {
            isImage(file) {
                const type = file.type;
                return type.indexOf('image') === 0;
            },
            onChange(e) {
                if (e.target.files.length === 0) {
                    return;
                }

                this.files = e.target.files;
                this.$emit('input', e.target.files);
                this.$emit('valueChanged', e.target.files, this.name);
            },
            setOverClass() {
                this.dropAreaClass.over = true;
            },
            removeOverClass() {
                this.dropAreaClass.over = false;
            },
            onUploadButtonClick() {
                this.$refs.input.click();
            }
        },
    });
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/forms/CustomFileInput.vue